import { Component } from '@angular/core';

@Component({
  selector: 'app-relevant-articles',
  templateUrl: './relevant-articles.component.html',
  styleUrls: ['./relevant-articles.component.css'],
})
export class RelevantArticlesComponent {}
